import { Trans } from '@lingui/react';
import cx from 'classnames';
import React from 'react';
import { usePricedCarsCounter } from '../../../hooks/usePricedCarsCounter';
import { usePricedCarsCounter as usePricedCarsCounterNumber } from '@wkda/carlead-creation-components';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomerCounter = ({
  className = '',
  textKey = 'carleadCreation.form.pricedCarCount.title'
}) => {
  const {
    isLoading
  } = usePricedCarsCounter();
  const {
    formatted: pricedCarCount
  } = usePricedCarsCounterNumber();
  return /*#__PURE__*/_jsx("h1", {
    className: `carlead-creation-form__title customer-counter text-center mb-5 ${className}`,
    children: /*#__PURE__*/_jsx(Trans, {
      id: textKey,
      values: {
        pricedCarCount
      },
      components: {
        0: /*#__PURE__*/_jsx("strong", {}),
        1: /*#__PURE__*/_jsx("br", {}),
        2: /*#__PURE__*/_jsx("strong", {}),
        3: /*#__PURE__*/_jsx("span", {
          className: cx('priced-car-counter', {
            'priced-car-counter__loading': isLoading
          })
        })
      }
    })
  });
};
export default CustomerCounter;